<template>
    <div style="margin-top: 30px;">
        <van-tabbar v-model="active">
            <van-tabbar-item icon="home-o">概要</van-tabbar-item>
            <van-tabbar-item icon="hot-o">白天</van-tabbar-item>
            <van-tabbar-item icon="star-o">晚上</van-tabbar-item>
        </van-tabbar>
        <div v-if="active==0">
            <van-tabs v-model="totalActive">
                <van-tab title="当天预约签到一览">
                    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                        <van-cell-group>
                            <van-cell title="白天健身预定人数" :value="bookedDay"
                                title-style="text-align:left;" />
                            <van-cell title="白天健身签到人数" :value="checkinDay"
                                title-style="text-align:left;" />
                            <van-cell title="白天签到比率" :value="dayCheckinRate.toFixed(2) + '%'"
                                title-style="text-align:left;" />
                        </van-cell-group>
                        <van-cell-group>
                            <van-cell title="晚上健身预定人数" :value="bookedNight"
                                title-style="text-align:left;" />
                            <van-cell title="晚上健身签到人数" :value="checkinNight"
                                title-style="text-align:left;" />
                            <van-cell title="晚上签到比率" :value="nightCheckinRate.toFixed(2) + '%'"
                                title-style="text-align:left;" />
                        </van-cell-group>
                    </van-pull-refresh>
                </van-tab>
                <van-tab title="每月预约签到一览">
                    <van-field readonly clickable
                        name="datetimePicker"
                        :value="monthValue" label="月份选择"
                        placeholder="点击选择月份"
                        @click="showPicker = true" />
                    <van-popup v-model="showPicker" position="bottom">
                        <van-datetime-picker type="year-month"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :formatter="formatter"
                            @confirm="onConfirm"
                            @cancel="showPicker = false" />
                    </van-popup>
                    <van-cell-group>
                        <van-cell title="白天健身预定人数" :value="bookedDayMonth"
                            title-style="text-align:left;" />
                        <van-cell title="白天健身签到人数" :value="checkinDayMonth"
                            title-style="text-align:left;" />
                        <van-cell title="白天签到比率" :value="dayCheckinRateMonth.toFixed(2) + '%'"
                            title-style="text-align:left;" />
                    </van-cell-group>
                    <van-cell-group>
                        <van-cell title="晚上健身预定人数" :value="bookedNightMonth"
                            title-style="text-align:left;" />
                        <van-cell title="晚上健身签到人数" :value="checkinNightMonth"
                            title-style="text-align:left;" />
                        <van-cell title="晚上签到比率" :value="nightCheckinRateMonth.toFixed(2) + '%'"
                            title-style="text-align:left;" />
                    </van-cell-group>
                </van-tab>
            </van-tabs>
        </div>
        <div v-if="active==1">
            <van-nav-bar title="白天预约人员表" />
            <van-tabs v-model="day_active">
                <van-tab title="全部预约">
                    <van-cell-group>
                        <van-cell v-for="item in dayBookingsAll" :key="item" :title="item" />
                    </van-cell-group>
                </van-tab>
                <van-tab title="已签到">
                    <van-cell-group>
                        <van-cell v-for="item in dayBookingsChecked" :key="item" :title="item" />
                    </van-cell-group>
                </van-tab>
                <van-tab title="未签到">
                    <van-cell-group>
                        <van-cell v-for="item in dayBookingsUnchecked" :key="item" :title="item" />
                    </van-cell-group>
                </van-tab>
            </van-tabs>
        </div>
        <div v-if="active==2">
            <van-nav-bar title="晚上预约人员表" />
            <van-tabs v-model="night_active">
                <van-tab title="全部预约">
                    <van-cell-group>
                        <van-cell v-for="item in nightBookingsAll" :key="item" :title="item" />
                    </van-cell-group>
                </van-tab>
                <van-tab title="已签到">
                    <van-cell-group>
                        <van-cell v-for="item in nightBookingsChecked" :key="item" :title="item" />
                    </van-cell-group>
                </van-tab>
                <van-tab title="未签到">
                    <van-cell-group>
                        <van-cell v-for="item in nightBookingsUnchecked" :key="item" :title="item" />
                    </van-cell-group>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

import { NavBar } from 'vant';
import { Form } from 'vant';
import { Field, CellGroup, PullRefresh, Notify, Tabbar, TabbarItem, Tab, Tabs } from 'vant';

export default {
    name: 'NuobaoStaff',
    data () {
        return {
            bookedDay: 0,
            bookedNight: 0,
            checkinDay: 0,
            checkinNight: 0,
            dayCheckinRate: 0,
            nightCheckinRate: 0,
            bookedDayMonth: 0,
            bookedNightMonth: 0,
            checkinDayMonth: 0,
            checkinNightMonth: 0,
            dayCheckinRateMonth: 0,
            nightCheckinRateMonth: 0,
            isLoading: false,
            active: 0,
            totalActive: 0,
            day_active: 0,
            night_active: 0,
            dayBookingsAll: [],
            dayBookingsChecked: [],
            dayBookingsUnchecked: [],
            nightBookings: [],
            nightBookingsChecked: [],
            nightBookingsUnchecked: [],
            thisDay: '',
            monthValue: 0,
            showPicker: false,
            minDate: new Date(2020, 3, 1),
            maxDate: new Date(2030, 3, 1)
        }
    },
    mounted() {
        this.onRefresh();
        var today = new Date();
        this.thisDay = this.formatDate(today);
        this.monthValue = this.formatMonth(today);
    },
    methods: {
        getMonthStatisticss() {
            var vm = this;
            //console.log("aaa");
            axios.get('/api/monthstatistics', {
                    params: {
                        ym: this.monthValue
                    }
                }).then((res) => {
                    console.log(res.data, '这个是获取调用扫描返回的参数?');
                    vm.bookedDayMonth = res.data["bookedDay"];
                    vm.bookedNightMonth = res.data["bookedNight"];
                    vm.checkinDayMonth = res.data["checkinDay"];
                    vm.checkinNightMonth = res.data["checkinNight"];
                    if (vm.checkinDayMonth == 0) {
                        vm.dayCheckinRateMonth = 0.0;
                    } else {
                        vm.dayCheckinRateMonth = 100.0 * vm.checkinDayMonth / vm.bookedDayMonth;
                    }
                    if (vm.checkinNightMonth == 0) {
                        vm.nightCheckinRateMonth = 0.0;
                    } else {
                        vm.nightCheckinRateMonth = 100.0 * vm.checkinNightMonth / vm.bookedNightMonth;
                    }
                    var d = new Date();
                    Notify({
                        type: 'success',
                        message: 'Updated at ' + d.toLocaleString(),
                        duration: 0
                    });
                    vm.isLoading = false;
                }).catch((error) => {
                    alert("无法获取数据!");
                    vm.isLoading = false;
                });
        },
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },
        onConfirm(time) {
            this.monthValue = this.formatMonth(time);
            this.showPicker = false;
            this.getMonthStatisticss();
        },
        formatMonth(date) {
            let m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            return `${date.getFullYear()}-${m}`;
        },
        formatDate(date) {
            let m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return `${date.getFullYear()}-${m}-${d}`;
        },
        updateDayBookings() {
            var vm = this;
            axios.get('/api/fblist',{
                params: {
                    'date': this.thisDay,
                    'slot': 1
                }
            }).then((res) => {
                vm.dayBookingsAll = [];
                vm.dayBookingsChecked = [];
                vm.dayBookingsUnchecked = [];
                let i, item;
                for (i = 0; i < res.data.length; i ++) {
                    item = res.data[i];
                    vm.dayBookingsAll.push(item.cec);
                    if (res.data[i].checked == 1) {
                        vm.dayBookingsChecked.push(item.cec);
                    } else {
                        vm.dayBookingsUnchecked.push(item.cec);
                    }
                }
            }).catch((error) => {
                alert("无法获取数据!");
            });
        },
        updateNightBookings() {
            var vm = this;
            axios.get('/api/fblist',{
                params: {
                    'date': this.thisDay,
                    'slot': 0
                }
            }).then((res) => {
                vm.nightBookingsAll = [];
                vm.nightBookingsChecked = [];
                vm.nightBookingsUnchecked = [];
                let i, item;
                for (i = 0; i < res.data.length; i ++) {
                    item = res.data[i];
                    vm.nightBookingsAll.push(item.cec);
                    if (res.data[i].checked == 1) {
                        vm.nightBookingsChecked.push(item.cec);
                    } else {
                        vm.nightBookingsUnchecked.push(item.cec);
                    }
                }
            }).catch((error) => {
                alert("无法获取数据!");
            });
        },
        onRefresh() {
            var vm = this;
            //console.log("aaa");
            axios.get('/api/statistics')
                .then((res) => {
                    console.log(res.data, '这个是获取调用扫描返回的参数?');
                    vm.bookedDay = res.data["bookedDay"];
                    vm.bookedNight = res.data["bookedNight"];
                    vm.checkinDay = res.data["checkinDay"];
                    vm.checkinNight = res.data["checkinNight"];
                    if (vm.checkinDay == 0) {
                        vm.dayCheckinRate = 0.0;
                    } else {
                        vm.dayCheckinRate = 100.0 * vm.checkinDay / vm.bookedDay;
                    }
                    if (vm.checkinNight == 0) {
                        vm.nightCheckinRate = 0.0;
                    } else {
                        vm.nightCheckinRate = 100.0 * vm.checkinNight / vm.bookedNight;
                    }
                    var d = new Date();
                    Notify({
                        type: 'success',
                        message: 'Updated at ' + d.toLocaleString(),
                        duration: 0
                    });
                    vm.isLoading = false;
                }).catch((error) => {
                    alert("无法获取数据!");
                    vm.isLoading = false;
                });
        }
    },
    watch: {
      active: function (val, oldVar) {
        if (val == 0 && oldVar != 0) {
            this.onRefresh();
        } else if (val == 1) {
            this.updateDayBookings();
        } else {
            this.updateNightBookings();
        }
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/NuobaoStaff.vue